import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadingFilesComponent } from './uploading-files.component';
import { MaterialModule } from "src/app/shared/material/material.module";
import { UploadingFilesRoutingModule } from './uploading-files-routing.module';
import { SpeedThresholdModule } from "src/app/shared/components/speed-threshold/speed-threshold.module";
import { FormsModule } from '@angular/forms';
import { AppBackButtonModule } from 'src/app/shared/components/app-back-button/app-back-button.module';



@NgModule({
  declarations: [
    UploadingFilesComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    UploadingFilesRoutingModule,
    SpeedThresholdModule,
    FormsModule,
    AppBackButtonModule,
],
  exports:[
    UploadingFilesComponent
  ]
})
export class UploadingFilesModule { }
